import { PickupAvailabilitiesDto } from "../gql/generated/graphql";

export interface FilteredPickupAvailability {
  pickupDate: string;
  packageReadyTime: string;
  clinicClosingTime: string;
}

export const GENERIC_DENTAL_OFFICE_OPENING_TIME = 8;
export const GENERIC_DENTAL_OFFICE_CLOSING_TIME = 18;

export const getOpeningAndClosingTimes = (
  availabilities: PickupAvailabilitiesDto
) => {
  const { pickupDate } = availabilities;

  const packageReadyTime = availabilities.readyTimeOptions.find(
    time =>
      Number(time.split(":")[0]) >= GENERIC_DENTAL_OFFICE_OPENING_TIME &&
      Number(time.split(":")[0]) < GENERIC_DENTAL_OFFICE_CLOSING_TIME
  );

  const clinicClosingTime = [...availabilities.latestTimeOptions]
    .reverse()
    .find(
      time =>
        Number(time.split(":")[0]) >= GENERIC_DENTAL_OFFICE_OPENING_TIME &&
        Number(time.split(":")[0]) < GENERIC_DENTAL_OFFICE_CLOSING_TIME
    );

  return {
    pickupDate,
    packageReadyTime,
    clinicClosingTime,
  };
};

export const filterPickupAvailabilitiesTime = (
  availabilities: PickupAvailabilitiesDto[]
): Array<FilteredPickupAvailability> => {
  return availabilities.reduce((filteredAvailabilities, availability) => {
    const { packageReadyTime, clinicClosingTime } =
      getOpeningAndClosingTimes(availability);
    if (packageReadyTime && clinicClosingTime) {
      filteredAvailabilities.push({
        pickupDate: availability.pickupDate,
        packageReadyTime,
        clinicClosingTime,
      });
    }
    return filteredAvailabilities;
  }, [] as Array<FilteredPickupAvailability>);
};
